import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AWSS3Image } from '../views/models/AWSS3Image.model';
import { ItemService } from './item.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AWSService {
  image_change$ = new BehaviorSubject<AWSS3Image[]>([]);
  catalogImage_change$ = new BehaviorSubject<AWSS3Image[]>([]);
  sliderImage_change$ = new BehaviorSubject<AWSS3Image[]>([]);
  logoImage_change$ = new BehaviorSubject<AWSS3Image>(new AWSS3Image());
  categoryImage_change$ = new BehaviorSubject<AWSS3Image | undefined>(undefined);

  constructor(private httpClient: HttpClient,
    public itemService: ItemService) {
  }

  uploadImage(hotelPhoto: Blob, id: number, directory: string, imageName: string) {
    const postImage = new FormData();
    postImage.append('file', hotelPhoto, imageName);
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/' + id + '/' + directory, postImage);
  }

  getImages(hotelid: number, directory: string, itemid?: number) {
    this.categoryImage_change$.next(undefined);
    this.httpClient.get(environment.baseURL + '/v2/api' + '/listbucketitems?bucketname=b1development&directory=icibotV2/' + hotelid + '/' + directory).subscribe(
      (datas: AWSS3Image[]) => {
        if (datas) {
          datas.forEach(x => x.url = x.url + '?' + (new Date()).getTime());
          datas.sort((a, b) => b > a ? -1 : 1);
          if (directory == 'Slider') {
            this.sliderImage_change$.next(datas);
          } else if (directory == 'Item Catalog') {
            if (itemid == null) {
              this.catalogImage_change$.next(datas);
              return;
            }
            const images = [];
            datas.forEach(x => {
              if (itemid == +x.file_name.split('_')[0]) {
                images.push(x);
              }
            });
            this.catalogImage_change$.next(images);
          } else if (directory == 'Items') {
            const images = [];
            datas.forEach(x => {
              if (itemid == +x.file_name.split('_')[0]) {
                images.push(x);
              }
            });
            if (images.length != 0) {
              const data = this.itemService.record_change$.getValue();
              if (data.id == itemid) {
                data.image_url = images[0].url;
                this.itemService.putItem(data);
              }
            }
            this.image_change$.next(images);
          } else if (directory == 'Categories') {
            datas.forEach(x => {
              if (itemid == +x.file_name.split('.')[0]) {
                this.categoryImage_change$.next(x);
              }
            });
          } else {
            this.logoImage_change$.next(datas[0]);
          }
        }

      },
      error => {
        console.log(error);
      },
    );
  }

  getImagesPromise(hotelid: number, directory: string, itemid?: number): Promise<string> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/listbucketitems?bucketname=b1development&directory=icibotV2/' + hotelid + '/' + directory).subscribe(
        (datas: AWSS3Image[]) => {
          if (datas) {
            datas.forEach(x => x.url = x.url + '?' + (new Date()).getTime());
            datas.sort((a, b) => b > a ? -1 : 1);

            const images = [];

            datas.forEach(x => {
              if (itemid == +x.file_name.split('_')[0]) {
                images.push(x);
              }
            });

            this.catalogImage_change$.next(images);

            resolve(images[0].url);
          }

        },
        error => {
          reject(error);
          console.log(error);
        },
      );
    })
  }

  deleteImage(id: number, directory: string, name: string) {
    return this.httpClient.delete(environment.baseURL + '/v2/api' + '/uploaddocument?bucketname=b1development&directory=icibotV2/' + id + '/' + directory + '/' + name);
  }

  copyImage(copy_source: string, key: string, metadata_directive: 'REPLACE' | 'COPY' = 'COPY') {
    // copySource => bucket_name + path
    // key => path
    return this.httpClient.post(environment.baseURL + '/v2/api' + '/copydocument', {
      bucket_name: 'b1development',
      copy_source,
      key,
      metadata_directive
    });
  }

  getBase64(link: string) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(environment.baseURL + '/v2/api/aws?link=' + link).subscribe(resp => {
        resolve(resp);
      }, err => {
        reject(err);
      });
    });
  }
}
